export enum ThresholdStatus {
  NOT_AVAILABLE = 'NOT_AVAILABLE',
  GOOD = 'GOOD',
  WARNING = 'WARNING',
  CRITICAL = 'CRITICAL'
}